import React, { useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { signInWithGoogle, signUpWithGoogle } from './firebase.js'; // Import your Firebase configuration and functions correctly
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import GoogleButton from 'react-google-button';
import '../styling/Login.css'; // Import your custom CSS for styling (if needed)
// useState
import { useState } from 'react';

function Login() {
  const [user, setUser] = useState(null); // Track the user's authentication status
  const auth = getAuth();

  // Check the user's authentication status when the component mounts
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });

    return () => {
      unsubscribe();
    };
  }, [auth]);

  return (
    <div className="container">
      <div className="login-container text-center">
        <p>Sign in or register to get started</p>
        <div 
          className="
            d-flex
            flex-column
            align-items-center
          "
        >
        <GoogleButton
          label="Sign in with Google"
          onClick={signInWithGoogle}
        />
        </div>
        <br></br>
        
        <p>OR</p>
        <p>Don't have an account? <span onClick={signUpWithGoogle} className="register-link">Register</span></p>
      </div>
    </div>
  );
}

export default Login;
